<mat-card class="system-card">
	<mat-card-header>
		<div class="card-header-row">
			<mat-card-title>
				@if (state.settlementBonusesLoading()) {
					<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
				}
				Dodatki / potrącenia ({{ state.settlementBonuses().length }})
			</mat-card-title>
			<div class="load-action">
				<button
					mat-stroked-button
					color="primary"
					type="button"
					[disabled]="state.isSettled()"
					[matTooltip]="state.isSettled() ? 'Miesiąc rozliczony — cofnij rozliczenie, aby dodawać.' : ''"
					(click)="openAddDialog()"
				>
					<mat-icon><i class="fa-solid fa-plus"></i></mat-icon>
					Dodaj dodatek/potrącenie
				</button>
				@if (state.navbridgeBonusesLoadedAt()) {
					<span class="loaded-at"
						>Ostatnio: {{ state.navbridgeBonusesLoadedAt() | date: 'd MMM yyyy, HH:mm' }}</span
					>
				}
				<span
					[matTooltip]="state.navbridgeBonusesTooltip()"
					[matTooltipDisabled]="!state.navbridgeBonusesTooltip()"
					matTooltipPosition="above"
				>
					<button
						mat-raised-button
						color="primary"
						(click)="state.loadNavbridgeBonuses()"
						[disabled]="state.navbridgeBonusesDisabled()"
					>
						@if (state.navbridgeBonusesLoading()) {
							<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
						}
						Ściągnij dodatki
					</button>
				</span>
			</div>
		</div>
	</mat-card-header>
	<mat-card-content>
		@if (state.isSettled()) {
			<div class="month-lock-banner">
				<mat-icon><i class="fa-solid fa-lock"></i></mat-icon>
				<span
					><strong>Miesiąc rozliczony — edycja zablokowana.</strong> Cofnij rozliczenie, aby wprowadzać
					zmiany.</span
				>
			</div>
		}
		@if (state.navbridgeBonusesError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd:</strong> {{ state.navbridgeBonusesError() }}</div>
			</div>
		}
		@if (state.navbridgeBonusesStats(); as stats) {
			@if (stats.updated > 0) {
				<div class="alert alert-info d-flex align-items-start mb-3" role="alert">
					<i class="bi bi-arrow-repeat me-2 mt-1"></i>
					<div>
						Zaktualizowano {{ stats.updated }} pozycji zmienionych w Nawigatorze. Zatwierdzone pozycje
						wróciły do statusu „Nowy" i wymagają ponownego zatwierdzenia.
					</div>
				</div>
			}
			@if (stats.skipped_locked > 0 || stats.skipped_no_driver > 0 || stats.errors > 0) {
				<div class="alert alert-warning d-flex align-items-start mb-3" role="alert">
					<i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
					<div>
						<strong>Ostrzeżenie:</strong>
						@if (stats.skipped_locked > 0) {
							{{ stats.skipped_locked }} pozycji zmieniło się w Nawigatorze, ale nie zostało nadpisanych
							(rozliczone, odrzucone lub edytowane ręcznie) — popraw je ręcznie.
						}
						@if (stats.skipped_no_driver > 0) {
							pominięto {{ stats.skipped_no_driver }} pozycji bez kierowcy.
						}
						@if (stats.errors > 0) {
							{{ stats.errors }} pozycji zakończyło się błędem.
						}
					</div>
				</div>
			}
		}
		@if (state.bonusesMissingPln() > 0) {
			<div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
				<i class="fa-solid fa-triangle-exclamation me-2"></i>
				<div>
					<strong>{{ state.bonusesMissingPln() }} poz. bez przeliczenia na PLN.</strong>
					Kurs NBP na dzień rozliczenia był niedostępny, więc kwoty w podsumowaniu mogą być nieprawidłowe.
				</div>
				<button
					mat-stroked-button
					type="button"
					class="ms-auto"
					[disabled]="state.recalculatePlnLoading()"
					(click)="state.recalculateBonusPln()"
				>
					@if (state.recalculatePlnLoading()) {
						<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
					}
					<mat-icon><i class="fa-solid fa-rotate"></i></mat-icon>
					Przelicz ponownie
				</button>
			</div>
		}
		@if (state.settlementActionError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="fa-solid fa-triangle-exclamation me-2"></i>
				<div><strong>Błąd:</strong> {{ state.settlementActionError() }}</div>
			</div>
		}
		<mat-accordion multi>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						Dodatki w miesiącu ({{ state.settlementPositive().length }})
						@if (state.settlementPositive().length > 0) {
							<span class="praca-total"
								>· {{ state.settlementPositiveTotal() | priceCurrency: 'PLN' }}</span
							>
						}
						@if (state.settlementPositivePending().length > 0) {
							<span
								class="pending-total"
								matTooltip="Pozycje niezatwierdzone nie wchodzą do podsumowania wynagrodzenia."
								matTooltipPosition="above"
								>· czeka na zatwierdzenie: {{ state.settlementPositivePending().length }} ·
								{{ state.settlementPositivePendingTotal() | priceCurrency: 'PLN' }}</span
							>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.settlementPositive().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.settlementPositive(); track row.id) {
							<app-salary-settlement-bonus-row
								[bonusId]="row.id"
								[date]="row.date"
								[name]="row.name"
								[amountGrosze]="row.amountGrosze"
								[currency]="row.currency"
								[plnGrosze]="row.plnGrosze"
								[exchangeRate]="row.exchangeRate"
								[exchangeRateDate]="row.exchangeRateDate"
								[plnConversionMissing]="row.plnConversionMissing"
								[confirmAt]="row.confirmAt"
								[bonusComment]="row.comment"
								[status]="row.status"
								[rejectedAt]="row.rejectedAt"
								[rejectReason]="row.rejectReason"
								[actions]="row.actions"
								[disabled]="state.isSettled()"
								[settlementDayTo]="row.settlementDayTo"
								[termsInMonth]="row.termsInMonth"
								[bonusDate]="row.bonusDate"
							/>
						}
					</div>
				} @else if (!state.settlementBonusesLoading()) {
					<p class="empty-state">Brak dodatków dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						Potrącenia w miesiącu ({{ state.settlementNegative().length }})
						@if (state.settlementNegative().length > 0) {
							<span class="praca-total"
								>· {{ state.settlementNegativeTotal() | priceCurrency: 'PLN' }}</span
							>
						}
						@if (state.settlementNegativePending().length > 0) {
							<span
								class="pending-total"
								matTooltip="Pozycje niezatwierdzone nie wchodzą do podsumowania wynagrodzenia."
								matTooltipPosition="above"
								>· czeka na zatwierdzenie: {{ state.settlementNegativePending().length }} ·
								{{ state.settlementNegativePendingTotal() | priceCurrency: 'PLN' }}</span
							>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.settlementNegative().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.settlementNegative(); track row.id) {
							<app-salary-settlement-bonus-row
								[bonusId]="row.id"
								[date]="row.date"
								[name]="row.name"
								[amountGrosze]="row.amountGrosze"
								[currency]="row.currency"
								[plnGrosze]="row.plnGrosze"
								[exchangeRate]="row.exchangeRate"
								[exchangeRateDate]="row.exchangeRateDate"
								[plnConversionMissing]="row.plnConversionMissing"
								[confirmAt]="row.confirmAt"
								[bonusComment]="row.comment"
								[status]="row.status"
								[rejectedAt]="row.rejectedAt"
								[rejectReason]="row.rejectReason"
								[actions]="row.actions"
								[disabled]="state.isSettled()"
								[settlementDayTo]="row.settlementDayTo"
								[termsInMonth]="row.termsInMonth"
								[bonusDate]="row.bonusDate"
							/>
						}
					</div>
				} @else if (!state.settlementBonusesLoading()) {
					<p class="empty-state">Brak potrąceń dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
		</mat-accordion>
	</mat-card-content>
</mat-card>
